import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import 'intersection-observer' // required polyfill
import Observer from '@researchgate/react-intersection-observer'

import styles from './lazyLoadImage.css'

class LazyLoadImage extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: props.immediate,
      loaded: false
    }

    this.handleLoad = this.handleLoad.bind(this)
    this.handleIntersect = this.handleIntersect.bind(this)
  }

  render () {
    const { alt, src } = this.props
    const { loading, loaded } = this.state
    const className = classnames(
      this.props.className,
      styles.image,
      {
        [styles.imageLoaded]: loaded
      }
    )

    if (loading || loaded) {
      return (
        <img src={src} className={className} onLoad={this.handleLoad} alt={alt} />
      )
    }

    return (
      <Observer onChange={this.handleIntersect} onlyOnce>
        <img data-src={src} className={className} alt={alt} />
      </Observer>
    )
  }

  handleLoad () {
    this.setState({
      loading: false,
      loaded: true
    })
  }

  handleIntersect (event) {
    if (event.isIntersecting && !this.state.loaded) {
      this.setState({
        loading: true
      })
    }
  }
}

LazyLoadImage.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string.isRequired,
  immediate: PropTypes.bool
}

LazyLoadImage.defaultProps = {
  className: '',
  immediate: false
}

export default LazyLoadImage
